import { refreshAndReload } from 'services/auth/actions'
import { selectLoggedIn } from 'services/user/selectors'
import { push } from 'connected-react-router'

export const unauthorizedMiddleware = (store) => (next) => (action) => {
  const state = store.getState()
  const isError = action.type.match(/ERROR$/)
  const is401 = isError && action.payload && action.payload.response && action.payload.response.status === 401
  const isLoggedIn = selectLoggedIn(state)
  const optOut = action.meta && action.meta.autoRefresh === false

  if (isLoggedIn && !optOut && isError && is401 && typeof window !== 'undefined') {
    const pathname = window.location.pathname
    const search = window.location.search

    store.dispatch(refreshAndReload({ quiet: false }))
      .then(() => {
        // HACK to force react-router to re-mount the current route
        // that way every page can reload their initial data
        store.dispatch(push('/'))
        store.dispatch(push({ pathname, search }))
      })
      .catch(() => {
        const originalUrl = `${pathname}${search}`
        const _next = encodeURIComponent(originalUrl)
        window.location.href = `/auth/login?next=${_next}`
      })
  } else {
    return next(action)
  }
}

export default unauthorizedMiddleware
